<template>
  <div>
    <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-2" />
    <v-textarea v-model="justificativa" label="Justificativa" no-resize outlined rows="4" class="mb-4" :disabled="loading" />
    <div class="align-center d-flex">
      <v-btn :disabled="loading || !justificativa" color="primary" outlined @click="salvarJustificativa()">
        <v-icon left x-small>mdi-content-save-outline</v-icon>
        Salvar
      </v-btn>
      <v-spacer />
      <v-btn :disabled="loading || !justificativa_id" color="error" outlined @click="excluirJustificativa()">
        <v-icon left x-small>mdi-delete-outline</v-icon>
        Excluir
      </v-btn>
    </div>
  </div>
</template>

<script>
  import ValidacoesBdgdsJustificativasService from '../../../services/ValidacoesBdgdsJustificativasService';

  export default {
    name: 'FormJustificativa',
    props: {
      testeSelecionado: {
        type: Object,
        required: true
      },
      item: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        loading: false,
        justificativa: null,
        justificativa_id: null
      };
    },
    mounted() {
      this.getJustificativa();
    },
    methods: {
      getJustificativa(silent = false) {
        if (!silent) this.loading = true;
        const { entidade, campo, nome_validacao, tipo_ocorrencia } = this.item;
        const sigla_teste = this.testeSelecionado.sigla_teste;
        ValidacoesBdgdsJustificativasService.getJustificativa({
          entidade,
          campo,
          nome_validacao,
          tipo_ocorrencia,
          sigla_teste
        })
          .then((response) => {
            const { id, justificativa } = response.data;
            this.justificativa_id = id;
            this.justificativa = justificativa;
          })
          .catch(() => {
            this.$toast.error(`Erro ao buscar a justificativa de "${this.item.nome_validacao}".`, '', {
              position: 'topRight'
            });
          })
          .finally(() => {
            if (!silent) this.loading = false;
          });
      },
      salvarJustificativa() {
        this.loading = true;
        const { entidade, campo, nome_validacao, tipo_ocorrencia } = this.item;
        const sigla_teste = this.testeSelecionado.sigla_teste;
        ValidacoesBdgdsJustificativasService.salvarJustificativa({
          entidade,
          campo,
          nome_validacao,
          tipo_ocorrencia,
          sigla_teste,
          justificativa: this.justificativa
        })
          .then((response) => {
            this.$toast.success(`Justificativa de "${this.item.nome_validacao}" salva com sucesso.`, '', {
              position: 'topRight'
            });
            this.$emit('justificativa-atualizada', { status: response.data.status });
            this.getJustificativa(true);
          })
          .catch(() => {
            this.$toast.error(`Erro ao salvar a justificativa de "${this.item.nome_validacao}".`, '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      },
      excluirJustificativa() {
        if (!confirm('Tem certeza que deseja excluir esta justificativa?')) return;
        this.loading = true;
        ValidacoesBdgdsJustificativasService.excluirJustificativa(this.justificativa_id)
          .then((response) => {
            this.$toast.success(`Justificativa de "${this.item.nome_validacao}" excluída.`, '', {
              position: 'topRight'
            });
            this.justificativa = null;
            this.justificativa_id = null;
            this.$emit('justificativa-atualizada', { status: response.data.status });
          })
          .catch(() => {
            this.$toast.error(`Erro ao excluir a justificativa de "${this.item.nome_validacao}".`, '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      }
    },
    watch: {
      item() {
        this.getJustificativa();
      }
    }
  };
</script>
